import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { changepayInfoData.CurrentIndex ,changepayInfoData.CurrentType} from '../../../action/productAction';
import Util from '../../../util';
import { hashHistory } from 'react-router';
import NavigatorMain from '../../NavigatorMain';
import {bankCode} from '../../../BankCode';
import ModalTip from '../../Modal/ModalTip';
import { AddCardHqtAlert } from '../../Modal/ModalList';
import ModalList from '../../Modal/ModalList';
import { myAddPhoneText,myAddCardText} from '../../../action/publicAction';
import { getOpenHqt, getPayAll } from '../../../getPay';
import store from '../../../ReduxStore.js';
import { findCamcHqtExist } from '../../../action/myAssets/userInfoAction'
import { Toast } from 'antd-mobile/lib';
import { getUserInfoList, getTbuxy, getTbuxyKh } from '../../../action/loginAction'
import { hqtXz } from "../../../action/investmentAction"


class PayCardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fundLimit:'',
      isOk:false,
      unUseBank:false,
      showMore:false,
      showMore2:false,
      unUseConent:'',
      setModalShow: false,
      theListResult: null,
      isOpenHqt: null,
      Bools: false,
      tanCar: false,
      dataVal: "",
      FundCode: "",
      yhkLx: false,
      isSignOnekeyFlag: false //直销卡签约弹窗
    };
  }
  callBack(){

  }
  componentWillMount() {
    document.title = "选择支付方式"
  }
  next(){
    this.setState({
      yhkLx:true
    })
    // console.log(this.props.location.state)
    // this.props.dispatch(myAddPhoneText(''));
    // this.props.dispatch(myAddCardText(''))
    // hashHistory.push({
    //     pathname:'/AddCard',
    //     state:{fundCode:this.props.location.state.fundCode,},

    // })
  }
  getUserInfo=()=>{
    console.log(this.props.location.state)
    this.props.dispatch(myAddPhoneText(''));
    this.props.dispatch(myAddCardText(''))
    hashHistory.push({
        pathname:'/AddCard',
        state:{fundCode:this.props.location.state.fundCode,},
    })
  }
  componentDidMount() {
    if(store.getState() && store.getState().verifiedUserInfo && store.getState().verifiedUserInfo.content) {
      let data = store.getState().verifiedUserInfo.content;
      this.setState({dataVal:data})
      console.log(data)
      let inParamsData = {
        certNo: data.certNo,
        certType: data.certType,
        name: data.name
      }
      store.dispatch(findCamcHqtExist(inParamsData, (result) => {
        console.log(result);
        this.setState({
          isOpenHqt: result.tradeAccountNo
        });
      }));
    }
  }
  choseBank(result,i){
    const { 
      payInfoData,dispatch
    }=this.props;
    let item=payInfoData.content.yhkNewListList[i];
    if (!item.disable) {
      console.log(result)
      this.setState({
        setModalShow:true,
        theListResult: result
      })
      return;
    }
    //直销卡没签约弹窗
    if(!(item.signOnekey === true || item.signTripleAgreement === true)) {
      this.setState({
        isSignOnekeyFlag: true
      });
      return;
    }
    // dispatch(changepayInfoData.CurrentType(1))
    // dispatch(changepayInfoData.CurrentIndex(i))
    Object.assign(payInfoData,{currentType:1},{currentIndex:i})
    dispatch({
      type:this.props.location.state.actionType+"_PAY_INFO",
      text:payInfoData
    });
    hashHistory.goBack()

  }
  closeModal = () => {
    this.setState({
      setModalShow: false
    });
  }
  
  
  okAddHqt = () => {
    // let { dispatch,payInfoData } = this.props;
    const { theListResult } = this.state;
    const { router, callback, isShow, fundCode } = this.props.location.state;
    let verifiedUserInfo = store.getState().verifiedUserInfo;
    const { name, certType, certNo, mobileNo } = verifiedUserInfo.content;
    let count = 0;
    this.setState({
      setModalShow: false
    });
    if(payInfoData.content.shareList.length>0) {
      for(let i = 0; i < payInfoData.content.shareList.length; i++) {
        if(payInfoData.content.shareList[i].bankAccountShowNo == theListResult.bankAccountShowNo && payInfoData.content.shareList[i].paymentChannel != "888") {
          count++;
          this.choseCurrent(i);
          break;
        }
      }
      if(count > 0) {
        return;
      }
      console.log(name,certType,certNo,mobileNo,router,callback,isShow)
      hashHistory.push({
        pathname: "/HqtBindCard",
        state: {
          bankAccountShowNo: theListResult.bankAccountShowNo,
          paymentChannelId: theListResult.paymentChannel,
          bankAccountName: theListResult.bankName,
          certType: certType,
          certNo:certNo,
          router: router,
          bankCode: theListResult.bankCode,
          openHqt: true,
          mobileNo: mobileNo,
          callback: callback,
          isShow: isShow,
          fundCode:fundCode
        }
      })
    }else {
      const _arr = this.state.theListResult;
      _arr.certType = certType;
      _arr.certNo = certNo;
      _arr.mobileNo = mobileNo;
      _arr.callback = callback;
      _arr.isShow = isShow;
      _arr.fundCode = fundCode;
      _arr.router = router;
      this.openHqt(_arr);
    }
    let { payInfoData } = this.props;
    if(payInfoData.content.shareList.length>0) {
      this.goHqtAddCard();
    }else {
      this.openHqt({fundCode: this.props.location.state.fundCode});
    }
  }
  choseCurrent(i){
    let { dispatch,payInfoData } = this.props;
    let item=payInfoData.content.shareList[i];
    if(item.paymentChannel == "G000") {
      if(item.ywt == false) {
        this.setState({
          unUseBank: true,
          unUseConent:'您的银行卡未签约，请登录华夏基金官网【银行卡管理-代扣签约】进行签约升级或咨询投资顾问。客服电话：400-817-5666'
        });
        return;
      }else if(item.ywt == null) {
        if (!item.enableCMBTrustChannel) {
          this.setState({
            unUseBank: true,
            unUseConent:'为确保资金同卡进出的原则, 请补充该招商银行卡信息, 该渠道活期通份额方可在华夏财富使用。您可以直接登录华夏财富官网个人中心提交银行卡信息, 或致电客服热线400- 817 - 5666进行办理。'
          });
          return;
        }
      }
    }else if (item.bankAccountShowNo2) {
      this.setState({
        unUseBank: true,
        unUseConent: `您在华夏基金的${item.trustChannelName.slice(-4)}(*${item.bankAccountShowNo.slice(-4)})与华夏财富的${item.trustChannelName.slice(-4)}(*${item.bankAccountShowNo2.slice(-4)})信息不一致,该渠道活期通暂不可用。如需银行卡信息变更,请您分别在华夏基金官网和华夏财富官网进行变更。如有疑问,请咨询客服热线400-817-5666。`,
      });
      return;
    }
    Object.assign(payInfoData,{currentType:2},{currentIndex:i})
    dispatch({
      type:this.props.location.state.actionType+"_PAY_INFO",
      text:payInfoData
    });
    hashHistory.goBack()
  }
  choseHB(i){
    let { dispatch ,payInfoData} = this.props;
    Object.assign(payInfoData,{currentType:3},{currentIndex:i})
    dispatch({
      type:this.props.location.state.actionType+"_PAY_INFO",
      text:payInfoData
    });
    hashHistory.goBack()
  }
  //活期通加卡
  goHqtAddCard() {
    console.log('加卡');
    hashHistory.push({
      pathname:'/HqtAddCard',
      state:{
        fundCode:this.props.location.state.fundCode
      }
    })
  }
  //开通活期通
  openHqt =async (arr)=> {
    if(this.state.isOpenHqt) {
      this.goHqtAddCard();
    }else {
      console.log('开通活期通');
      this.setState({
        tanCar:true,
        FundCode:arr.fundCode
      })
    }
  }

  closeMoadlLft = () => {
    this.setState({
      tanCar: false
    })
  }

  closeMoadls = ()=>{
    if(this.state.Bools){
      this.props.dispatch(getTbuxyKh({},()=>{
        this.setState({
          tanCar:false
        })
        getOpenHqt(window.history.length,hashHistory,null,{fundCode:this.state.FundCode})
        let data = store.getState().verifiedUserInfo.content;
        console.log(data)
        let inParamsData = {
          certNo: data.certNo,
          certType: data.certType,
          name: data.name
        }
        store.dispatch(findCamcHqtExist(inParamsData, (result) => {
          console.log(result);
          this.setState({
            isOpenHqt: result.tradeAccountNo
          });
        }));
      }))
    }else{
      Toast.info("请先阅读并确认用户同步信息授权书",2);
      return
    }
	}

  goHQT(parmas,val){
    let { navigator ,dispatch,fundCode} = this.props;
    let data={
      fundCode:'003003',
      businessType:'T022',
      productType:'G',
      type:'superFund',
      bankAccountShowNo:parmas.bankAccountShowNo,
      currentIndex:val,
    }
    this.props.dispatch(hqtXz(parmas.bankCode))
    Object.assign(this.props.payInfoData,{currentType:2},{currentIndex:val})
    getPayAll( window.history.length, data, hashHistory, 'RechargeHqt')
  }

  isSignOnekeyModalOk = () => {
    this.setState({
      isSignOnekeyFlag: false
    });
  }
  render(){
    const { 
      payInfoData,
    }=this.props;
    let { active  } = this.props;
    console.log(payInfoData,"99999999999999")
    let icon=[require('../../../imgs/zflb_moren.png'),require('../../../imgs/zflb_yxz.png')];
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>选择支付方式</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div style={{background:"rgba(255, 255, 255, 1)"}} className='content' >
            {
              this.state.yhkLx?
              <div style={{background:"rgba(0, 0, 0, 0.3)",left:0,top:0,position:"fixed",width:"100%",height:"100%"}}>
                <div style={{height:"5.5rem",position:"fixed",bottom:0,background:"rgba(255, 255, 255, 1)",width:"100%",padding:"0.4rem"}}>
                  <div style={{width:"100%",display:"flex"}}>
                    <div style={{width:"0.36rem",height:"0.36rem"}}></div>
                    <div style={{flex:1,color:"rgba(51, 51, 51, 1)",fontSize:"0.36rem",fontWeight:"bold",textAlign:"center"}}>选择银行卡类型</div>
                    <img onClick={()=>{this.setState({yhkLx:false})}} src={ require('../../../imgs/tjyhk_qx.png')} style={{width:"0.36rem",height:"0.36rem"}} className='img'/>
                  </div>
                  <div style={{width:"100%",display:"flex",marginTop:"0.4rem"}}>
                    {/* <img src={ require('../../../imgs/tjyhk_qx.png')} style={{width:"0.36rem",height:"0.36rem"}} className='img'/> */}
                    <div onClick={()=>{ payInfoData.content.shareList.length>0?this.goHqtAddCard():this.openHqt({fundCode: this.props.location.state.fundCode})}} style={{background:"rgba(227, 212, 190, 1)",display:"flex",alignItems:"center",paddingBottom:"0.7rem",width:"3.2rem",height:"1.64rem",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.2rem",position:"relative",borderRadius:"0.08rem"}}>
                      <div style={{flex:1,fontSize:"0.32rem",color:"rgba(95, 80, 61, 1)",fontWeight:"bold"}}>华夏基金直销银行卡</div>
                      <img src={ require('../../../imgs/xayhk_lx.png')} style={{width:"0.6rem",height:"0.36rem",marginRight:"0.1rem"}}/>
                      <img src={ require('../../../imgs/c_hxcf_icon_youjiantou_10_grayss.png')} style={{width:"0.2rem",height:"0.2rem"}}/>
                      <img src={ require('../../../imgs/sgyhk.png')} style={{width:"0.88rem",height:"0.64rem",position:"absolute",right:0,bottom:0}}/>
                    </div>
                    <div style={{flex:1}}></div>
                    <div onClick={()=>{this.getUserInfo()}} style={{width:"3.2rem",height:"1.64rem",background:"rgba(222, 225, 236, 1)",display:"flex",alignItems:"center",paddingBottom:"0.7rem",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.2rem",position:"relative",borderRadius:"0.08rem"}}>
                      <div style={{flex:1,fontSize:"0.32rem",color:"rgba(61, 67, 87, 1)",fontWeight:"bold"}}>华夏财富银行卡</div>
                      <img src={ require('../../../imgs/c_hxcf_icon_youjiantou_10_grayss.png')} style={{width:"0.2rem",height:"0.2rem"}}/>
                      <img src={ require('../../../imgs/ylyhk.png')} style={{width:"0.88rem",height:"0.64rem",position:"absolute",right:0,bottom:0}}/>
                    </div>
                    {/* <img src={ require('../../../imgs/tjyhk_qx.png')} style={{width:"0.36rem",height:"0.36rem"}} className='img'/> */}
                  </div>
                  <div style={{fontSize:"0.24rem",color:"rgba(153, 153, 153, 1)",lineHeight:"0.34rem",marginTop:"0.4rem",marginBottom:"0.8rem"}}>
                    1、选择添加“华夏基金直销银行卡”，您将在华夏基金的直销端通道绑定银行卡，该类银行卡的支付额度较高，建议使用。<br></br>
                    2、选择添加“华夏财富银行卡”，您将在华夏财富端的银联通通道绑定银行卡，该类银行卡的支付额度较低。
                  </div>
                </div>
              </div>
              :null
            }
          {
            payInfoData.content.currencyFund.length>0?<div style={{paddingTop:"0.4rem",paddingLeft:"20px",fontSize:"0.28rem",paddingBottom:"0.1rem"}}>零钱宝支付</div>:null
          }
          {
            payInfoData.content.currencyFund.map( (item,i) =>{
              return(
                <div key={`shareList${i}`} style={!this.state.showMore&&i>1?{display:'none'}:null}  className={payInfoData.currentType===3&&payInfoData.currentIndex===i?'bankLists':"bankListss"} onClick={()=>this.choseHB(i)}>
                  <img src={ require('../../../img/icon_LQB.png')} style={{width:40,height:40,alignSelf:"center"}}/>
                  <div style={{flex:1,paddingLeft:"0.2rem"}}>
                    <p style={{color:"rgba(51, 51, 51, 1)",fontSize:"0.28rem"}}>{item.fundName}</p>
                    <p style={{color:"rgba(102, 102, 102, 1)",fontSize:"0.24rem",paddingBottom:"0.1rem",paddingTop:"0.1rem"}}>{Util.formatStr(item.trustChannelName)+' (*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+")"}</p>
                    <p style={{fontSize:"0.24rem"}}><span style={{color:"rgba(102, 102, 102, 1)"}}>可用余额 ：</span><span style={{color:"rgba(249, 44, 61, 1)"}}>{Util.parsePrice(item.availableVolume)}</span></p>
                  </div>
                  <div className='bankListRightOK'>
                    <img src={payInfoData.currentType===3&&payInfoData.currentIndex===i?icon[1]:icon[0]} style={{width:"0.4rem",height:"0.4rem",alignSelf:"center"}}/>
                  </div>
                </div>
              )
            })
          }
          {
            payInfoData.content.currencyFund.length>2?<div className='bankTypeBtn' onClick={()=>this.setState({showMore:!this.state.showMore})}>
              <p>更多零钱宝支付方式</p>
              <img src={require('../../../img/arrowBm.png')} className={this.state.showMore?'transform180':null}/>
            </div>:payInfoData.content.currencyFund.length!=0?<div style={{height:20}}/>:null
          }
          {
            payInfoData.content.currencyFund.length>0?<div style={{height:"10px",background:"rgba(248, 248, 248, 1)"}}></div>:null
          }
          {
            <div className='bankTypeNames' style={{paddingRight: "20px"}}>
              活期通支付
              <div style={{flex:1}}></div>
              {
                payInfoData.content.shareList.length>0?
                <span style={{color:"red"}} onClick={()=>this.goHqtAddCard()}>+增开活期通</span>
                :
                <span style={{color:"red"}} onClick={()=>this.openHqt({fundCode: this.props.location.state.fundCode})}>+开通活期通</span>
              }
            </div>
          }
          {
            payInfoData.content.shareList.map( (item,i) =>{
              if((item.paymentChannel == "G000" && !item.enableCMBTrustChannel) || item.enableCMBTrustChannel === '0') {
                return(
                  <div key={`shareList${i}`} style={!this.state.showMore2&&i>1?{display:'none'}:{}}  className={payInfoData.currentType===2&&payInfoData.currentIndex===i?'bankLists':"bankListss"} onClick={()=>this.choseCurrent(i)}>
                    {
                      item.paymentChannel=='888'?
                      <img src={ require('../../../img/bank.png')}  style={{width:40,height:40,alignSelf:"center"}}/>:
                      <img src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')} style={{width:40,height:40,alignSelf:"center"}}/>
                    }
                    <div style={{flex:1,paddingLeft:"0.2rem"}}>
                      <div style={{color:"rgba(51, 51, 51, 1)",fontSize:"0.28rem"}}>活期通</div>
                      {
                        item.paymentChannel=='888'?
                        <p style={{color:"rgba(102, 102, 102, 1)",fontSize:"0.24rem",paddingBottom:"0.1rem",paddingTop:"0.1rem"}}>活期通{item.enableCMBTrustChannel==='0'?<span style={{color: 'rgb(104,113,126)', fontSize: 12, padding: 2, backgroundColor: "rgba(0,0,0,0.1)"}}>不可用</span>:null}</p>
                        :
                        item.paymentChannel == "G000" && item.ywt == null ?
                        <p style={{color:"rgba(102, 102, 102, 1)",fontSize:"0.24rem",paddingBottom:"0.1rem",paddingTop:"0.1rem"}}>{Util.formatStr(item.trustChannelName).indexOf('-')>-1?item.trustChannelName.split('-')[1]:"--"} {'(*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}{(item.paymentChannel == "G000"&&!item.enableCMBTrustChannel) || item.enableCMBTrustChannel==='0'?<span style={{color: 'rgb(104,113,126)', fontSize: 12, padding: 2, backgroundColor: "rgba(0,0,0,0.1)"}}>不可用</span>:null}</p>
                        :
                        <p style={{color:"rgba(102, 102, 102, 1)",fontSize:"0.24rem",paddingBottom:"0.1rem",paddingTop:"0.1rem"}}>{Util.formatStr(item.trustChannelName).indexOf('-')>-1?item.trustChannelName.split('-')[1]:"--"} {'(*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}</p>
                      }
                      {
                        item.paymentChannel == "G000" && item.ywt == false ?
                        <p style={{fontSize:"0.24rem"}}>招行卡暂不可用，请您去华夏基金管家App操作或咨询客服</p>
                        :
                        <p style={{fontSize:"0.24rem"}}><span style={{color:"rgba(102, 102, 102, 1)"}}>可用余额 ：</span><span style={{color:"rgba(249, 44, 61, 1)"}}>{Util.parsePrice(item.availableVolume)}</span><span onClick={()=>this.goHQT(payInfoData.content.shareList[i],i)} style={{color:"rgba(173, 127, 72, 1)",marginLeft:10}}>充值</span></p>
                      }
                    </div>
                    <div className='bankListRightOK'>
                      <img src={payInfoData.currentType===2&&payInfoData.currentIndex===i?icon[1]:icon[0]} style={{width:"0.4rem",height:"0.4rem",alignSelf:"center"}}/>
                    </div>
                  </div>
                )
              }else {
                return(
                  <div key={`shareList${i}`} style={!this.state.showMore2&&i>1?{display:'none'}:{}}  className={payInfoData.currentType===2&&payInfoData.currentIndex===i?'bankLists':"bankListss"} onClick={()=>this.choseCurrent(i)}>
                    {
                      item.paymentChannel=='888'?
                      <img src={ require('../../../img/bank.png')}  style={{width:40,height:40,alignSelf:"center"}}/>:
                      <img src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')} style={{width:40,height:40,alignSelf:"center"}}/>
                    }
                    <div style={{flex:1,paddingLeft:"0.2rem"}}>
                      <div style={{color:"rgba(51, 51, 51, 1)",fontSize:"0.28rem"}}>活期通</div>
                      {
                        item.paymentChannel=='888'?
                        <p style={{color:"rgba(102, 102, 102, 1)",fontSize:"0.24rem",paddingBottom:"0.1rem",paddingTop:"0.1rem"}}>活期通</p>
                        :
                        <p style={{color:"rgba(102, 102, 102, 1)",fontSize:"0.24rem",paddingBottom:"0.1rem",paddingTop:"0.1rem"}}>{Util.formatStr(item.trustChannelName).indexOf('-')>-1?item.trustChannelName.split('-')[1]:"--"} {'(*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}</p>
                      }
                      {
                        item.paymentChannel == "G000" && item.ywt == false ?
                        <p style={{fontSize:"0.24rem"}}>招行卡暂不可用，请您去华夏基金管家App操作或咨询客服</p>
                        :
                        <p style={{fontSize:"0.24rem"}}><span style={{color:"rgba(102, 102, 102, 1)"}}>可用余额 ：</span><span style={{color:"rgba(249, 44, 61, 1)"}}>{Util.parsePrice(item.availableVolume)}</span><span onClick={()=>this.goHQT(payInfoData.content.shareList[i],i)} style={{color:"rgba(173, 127, 72, 1)",marginLeft:10}}>充值</span></p>
                      }
                    </div>
                    <div className='bankListRightOK'>
                      <img src={payInfoData.currentType===2&&payInfoData.currentIndex===i?icon[1]:icon[0]} style={{width:"0.4rem",height:"0.4rem",alignSelf:"center"}}/>
                    </div>
                  </div>
                )
              }
            })
          }
          {
            payInfoData.content.shareList.length>2?<div className='bankTypeBtn' onClick={()=>this.setState({showMore2:!this.state.showMore2})}>
              <p>更多活期通支付方式</p>
              <img src={require('../../../img/arrowBm.png')} className={this.state.showMore2?'transform180':null}/>
            </div>:payInfoData.content.shareList.length!=0?<div style={{height:20}}/>:null
          }
          {
            payInfoData.content.yhkNewListList.length>-1?<div style={{height:"10px",background:"rgba(248, 248, 248, 1)"}}></div>:null
          }
          {
            payInfoData.content.yhkNewListList.length>-1?<div style={{paddingTop:"0.4rem",paddingLeft:"20px",fontSize:"0.28rem",paddingBottom:"0.1rem"}}>银行卡支付</div>:null
          }
          {
            payInfoData.content.yhkNewListList.map( (item,i)=> {
              if (item.paymentChannel=='888') {
                return(
                  <div key={`current${i}`} className={payInfoData.currentType===1&&payInfoData.currentIndex===i?'yhbankLists':"yhbankListss"} style={!item.disable?{backgroundColor:"rgba(0,0,0,0.1)"}:null} onClick={()=>this.choseBank(item,i)}>
                    <img src={ require('../../../img/bank.png')} style={{width:40,height:40,alignSelf:"center"}}/>
                    <div style={{flex:1,paddingLeft:"0.2rem"}} >
                      <p style={{color:"rgba(51, 51, 51, 1)",fontSize:"0.28rem"}}>理财中心</p>
                      <p style={{color:"rgba(102, 102, 102, 1)",fontSize:"0.24rem"}}>理财中心POS机刷卡</p>
                    </div>
                    <div className='bankListRightOK'>
                      <img src={payInfoData.currentType===1&&payInfoData.currentIndex===i?icon[1]:icon[0]} style={{width:"0.4rem",height:"0.4rem",alignSelf:"center"}}/>
                    </div>
                  </div>
                )
              }else{
                return(
                  <div key={`current${i}`} className={payInfoData.currentType===1&&payInfoData.currentIndex===i?'yhbankLists':"yhbankListss"} style={!item.disable?{backgroundColor:"rgba(0,0,0,0.1)"}:null} onClick={()=>this.choseBank(item,i)}>
                    <img src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')} style={{width:40,height:40,alignSelf:"center"}}/>
                    <div style={{flex:1,paddingLeft:"0.2rem"}} >
                      <p style={{color:"rgba(51, 51, 51, 1)",fontSize:"0.28rem"}}>{(item.yhkBool?"直销银行卡-":"财富银行卡-")+Util.formatStr(item.bankName)+' (*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}</p>
                      <p style={{color:"rgba(102, 102, 102, 1)",fontSize:"0.24rem",marginTop:"0.1rem"}}>{item.yhkBool ? window.funSplit(item.tradeMaxAmountTips)[0]>=999999999999 ? '单笔无限额，单日无限额' : item.paymentChannelId=='G000' && item.bankCode=='007' ? '单笔限额20万，单日限额20万' : item.dayMonthLimit && window.funSplit(item.tradeMaxAmountTips)[0] ? "单笔限额"+window.funSplit(item.tradeMaxAmountTips)[0]/10000+"万"+item.dayMonthLimit : window.funSplit(item.tradeMaxAmountTips)[0] ? "单笔限额"+window.funSplit(item.tradeMaxAmountTips)[0]/10000+"万" : '' : window.funSplit(item.tradeMaxAmountTips)[1]}</p>
                    </div>
                    <div className='bankListRightOK'>
                      <img src={payInfoData.currentType===1&&payInfoData.currentIndex===i?icon[1]:icon[0]} style={{width:"0.4rem",height:"0.4rem",alignSelf:"center"}}/>
                    </div>
                  </div>
                )
              }
            })
          }
          <div onClick={()=>this.next()} className='yhbtn' >+添加银行卡</div>
          </div>

          <ModalTip onCancel={()=>{this.setState({unUseBank:false})}} onOK={()=>{this.setState({unUseBank:false})}} flag={this.state.unUseBank} height={240} title = '银行渠道提示' content = {this.state.unUseConent}   />
          {
            this.state.setModalShow ?
            <AddCardHqtAlert 
              title={"温馨提示"} 
              content={"很抱歉，该银行卡暂不支持扣款，建议您使用活期通进行支付。"}
              CloseAler = { ()=> { this.setState({ setModalShow:false }) } }
              handleBtn1 = { this.okAddHqt }
              handleBtn2 = { this.closeModal }
              btnfirText="活期通支付"
              btnsecText="其他银行卡支付"
            /> : null
          }
          <ModalList onFun={(Bools)=>{this.setState({Bools:Bools})}} flag={this.state.tanCar} btnLiftFun={this.closeMoadlLft} btnLift={"取消"} btnRight={"确认"} btnRightFun={this.closeMoadls} content={"为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》"} title={""} />
          <ModalList flag={this.state.isSignOnekeyFlag} btnRight={"确认"} btnRightFun={this.isSignOnekeyModalOk} content={"您选择的银行卡尚未进行签约升级，需升级后才可进行支付，详情请咨询客服400-817-5666"} title={"温馨提示"} />
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  console.log(ownProps.location.state.type+'PayInfo');
  return {
    payInfoData:state[ownProps.location.state.type+'PayInfo'],
  }
}
export default connect(mapStateToProps)(PayCardList);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/PayCardList.js